'use client';

import "core-js/modules/es.date.to-string.js";
function getPrecision(step) {
  if (!step) return 0;
  var split = step.toString().split(".");
  return split.length > 1 ? split[1].length : 0;
}
export { getPrecision };